import React from "react";
import dash from "../images/dashboadnew.png";
import check from "../images/Checkmark.png";
import { Link } from "react-router-dom";

const Logimg = () => {
  const path = window.location.pathname;
  return (
    <div className="col-lg-7">
      <div className="login-page-right">
        <div className="right-div-12">
          <button className="Looking-bt">
            <Link
              to="https://edubridge.org.uk/how-it-works"
              className="text-white text-decoration-none"
              target="blank"
            >
              Looking for 1:1 tutoring?
            </Link>
          </button>
        </div>
        <p className="Revolutionise">
          Revolutionise your revision <span>with AI</span>
        </p>
        <div className="card-div">
          <div id="carouselExampleIndicators" className="carousel slide">
            {/* <div className="carousel-indicators">
              <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to={0}
                className="active"
                aria-current="true"
                aria-label="Slide 1"
              />
              <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to={1}
                aria-label="Slide 2"
              />
              <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to={2}
                aria-label="Slide 3"
              />
            </div> */}
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img src={dash} className="dashboadnew" alt="" />
              </div>
              {/* <div className="carousel-item">
                <img src={dash} className="dashboadnew" alt="" />
              </div>
              <div className="carousel-item">
                <img src={dash} className="dashboadnew" alt="" />
              </div> */}
            </div>
            {/* <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev"
            >
              <span className="carousel-control-prev-icon" aria-hidden="true" />
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon" aria-hidden="true" />
              <span className="visually-hidden">Next</span>
            </button> */}
          </div>
        </div>
        <ul className="ul-resol">
          <li>
            <img src={check} className="check-mark" alt="" />
            <span>
              Generate quizzes specific to subjects, exam boards, topics, and
              levels
            </span>
          </li>
          <li>
            <img src={check} className="check-mark" alt="" />
            <span>
              Experience interactive quiz formats, multiple question types and
              instant feedback
            </span>
          </li>
          <li>
            <img src={check} className="check-mark" alt="" />
            <span>
              Monitor your progress and build your knowledge so you can feel
              confident for your exams
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Logimg;
